module.exports = __webpack_public_path__ + "img/sopur.1f55bfeb.jpg";